'use client';

import { useTheme } from 'next-themes';
import type { CSSProperties } from 'react';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ closeButton = true, style, toastOptions, ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();
  const toasterStyle = {
    '--toast-close-button-start': 'unset',
    '--toast-close-button-end': '0',
    '--toast-close-button-transform': 'translate(35%, -35%)',
    ...style,
  } as CSSProperties;

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      closeButton={closeButton}
      className="toaster group"
      style={toasterStyle}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-foreground/80',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
          closeButton:
            'group-[.toast]:border-border group-[.toast]:bg-background/80 group-[.toast]:text-foreground hover:group-[.toast]:bg-muted',
          ...toastOptions?.classNames,
        },
        ...toastOptions,
      }}
      {...props}
    />
  );
};

export { Toaster };
